import React from 'react';
import { GoVerified } from "react-icons/go";

import { Container } from './styles';

function FinishAlert({ type, examResponseCrCode }) {

  if (type === 'EXAM' || type === 'Exame') {
    return (
      <Container>
        <GoVerified />
        <h3>Envio realizado com Sucesso!</h3>
        <p>Protocolo de envio é: {examResponseCrCode}</p>
      </Container>
    )
  }

  if (type ==='SELF_ASSESSMENT') {
    return (
      <Container>
        <GoVerified />
        <h3>Envio realizado com Sucesso!</h3>
        <p>Seu protocolo de envio é: {examResponseCrCode}</p>
      </Container>
    );
  }

  return (
    <Container>
      <GoVerified />
      <h3>Envio realizado com Sucesso!</h3>
      <p>Seu protocolo de envio é: {examResponseCrCode}</p>
    </Container>
  );
}

export default FinishAlert;
